import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type Alert = {
  message: string;
  severity: 'info'|'success'|'warning'|'danger';
};

export type AlertsState = {
  alerts: Alert[];
};

const initialState: AlertsState = {
  alerts: [],
};

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addSuccessAlert: (state, action: PayloadAction<string>) => {
      state.alerts = [{ message: action.payload, severity: 'success' }];
    },
    addInfoAlert: (state, action: PayloadAction<string>) => {
      state.alerts = [{ message: action.payload, severity: 'info' }];
    },
    addWarningAlert: (state, action: PayloadAction<string>) => {
      state.alerts = [{ message: action.payload, severity: 'warning' }];
    },
    addDangerAlert: (state, action: PayloadAction<string>) => {
      state.alerts = [{ message: action.payload, severity: 'danger' }];
    },
  },
});

export const {
  addSuccessAlert,
  addInfoAlert,
  addWarningAlert,
  addDangerAlert
} = alertsSlice.actions;

export default alertsSlice.reducer;